export { TableMerchant, TableStaticMerchant } from './components/TableMerchant';
